module.exports = __webpack_public_path__ + "static/media/svg4.d4e9dc07.svg";